module.exports = ['$scope', 'ngDroUAA', 'ngDroUtilsNotify', '$state', 'CanDoServices',
    function ($scope, ngDroUAA, ngDroUtilsNotify, $state, CanDoServices) {
        /*
         * Config
         */

        // Informazioni per la parametrizzazione della direttiva button-add.
        $scope.infoAdd = {icon: 'fa-shield', message: 'jdro_role.add'};

        /*
         * Init
         */

        // Ottengo i permessi per le operazioni Create, Update, Delete dei ruoli
        CanDoServices.canDo("ROLE").then(function (perms) {
            $scope.jdroPerms = perms;
        });

        // Caricamento dei Ruoli al caricamento della pagina.
        loadRoles();

        /*
         * Methods
         */

        function loadRoles() {
            ngDroUAA.Role.findAll()
                    .then(function (response) {
                        $scope.roles = response.data;
                $scope.$eval("roles| filter:query | orderBy:ordering:reverse");
                    })
                    .catch(function (err) {
                        ngDroUtilsNotify.error(null, 'jdro_role.error.find_all', null, err);
                    });
        };

        $scope.remove = function (role) {
            if (!role.id) {
                $scope.loadRoles();
                return;
            }
            options = {
                success: function () {
                    ngDroUAA.Role.delete(role.id)
                            .then(function () {
                                ngDroUtilsNotify.deleteSuccess(role.roleCode);
                                $scope.loadRoles();
                            })
                            .catch(function (err) {
                                ngDroUtilsNotify.deleteError(role.roleCode, err);
                            });
                },
                itemTitle: role.roleCode,
                headTitle: 'jdro_role.confirm_delete'
            };
            ngDroUtilsNotify.confirmDelete(options);
        };

        $scope.add = function () {
            $state.go('uaa-module-role-add');
        };

        $scope.edit = function (item) {
            $state.go('uaa-module-role-edit', {id: item.id});
        };

    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/role/roleList/roleListCtrl.js
// module id = 429
// module chunks = 0